export default {"src":"/_next/static/media/clients-circular.e41d5e05.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};